// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"7df124a0","354":"76c3f748","455":"cb82b43c","488":"f25c3c27","614":"fbca402a","685":"785da664","977":"65c0565d"}[chunkId] + ".chunk.js";
};